import type { StyledComponent } from '@emotion/styled';
import type { TooltipProps } from '@mui/material/Tooltip';

import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';

const InvalidTooltip: StyledComponent<TooltipProps> = styled(
    ({ className, ...props }: TooltipProps) => (
        <Tooltip
            classes={{ popper: className }}
            {...props}
            placement="bottom-start"
            slotProps={{
                ...props.slotProps,
                popper: {
                    ...(typeof props.slotProps?.popper === 'object'
                        ? props.slotProps.popper
                        : undefined),
                    modifiers: [
                        /**
                         * This offset modifier overrides the tooltip position relative to the anchor.
                         * For the invalid tooltip, we want the tooltip to "glued" against the field.
                         * There is a default gap between the tooltip and the anchor, so we need to set the offset to a negative value to remove that gap.
                         */
                        {
                            name: 'offset',
                            options: {
                                offset: [-3, -13],
                            },
                        },
                        ...((typeof props.slotProps?.popper === 'object' &&
                            Array.isArray(props.slotProps.popper.modifiers) &&
                            props.slotProps.popper.modifiers) ||
                            []),
                    ],
                },
            }}
            /**
             * Since this tooltip is "glued" to the field,
             * the arrow is unnecessary and looks weird.
             */
            arrow={false}
        />
    )
)(({ theme }) => ({
    //Styles for the tooltip
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.background.default,
        ...theme.typography['captions.default'],
        /**
         * Since we "glue" the tooltip to the field at the very left edge,
         * we also need to override the transform origin for the opening and closing animations.
         */
        transformOrigin: 'top left !important',
    },
}));

export { InvalidTooltip };
